import { Info, HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * HelpTip — "modo anti-confusión" para FindMed.
 *
 * Variantes:
 *   1) <HelpTip text="..." />               -> Ícono (i) gris pequeño con tooltip al hover.
 *   2) <HelpTip text="..." variant="?" />   -> Ícono (?) circular (uso en headers).
 *   3) <HelpTip text="...">contenido</HelpTip> -> Envuelve cualquier elemento; hover muestra explicación.
 *
 * También aplica `title` como fallback para máxima compatibilidad y accesibilidad.
 */
export default function HelpTip({ text, children, variant = "i", side = "top", className = "" }) {
    if (!text) return children || null;

    const Icon = variant === "?" ? HelpCircle : Info;

    const trigger = children ?? (
        <span className={`inline-flex items-center justify-center text-slate-400 hover:text-sky-600 cursor-help ${className}`}>
            <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
        </span>
    );

    return (
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span title={text} aria-label={text} className="inline-block">
                        {trigger}
                    </span>
                </TooltipTrigger>
                <TooltipContent
                    side={side}
                    className="max-w-xs text-xs leading-snug bg-slate-900 text-white font-normal"
                >
                    {text}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
